// extracted by mini-css-extract-plugin
export default {"container":"form-label_container__6pN7f","truncate-table":"form-label_truncate-table__3qYHI","table-text-faded":"form-label_table-text-faded__q5dTx","formLabel":"form-label_formLabel__XTzDN","label":"form-label_label__jMgmp","optional":"form-label_optional__3vJBm"};
    if(module.hot) {
      // 1793877085052
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  